export enum FieldType {
  DOUBLE = 'double',
  INTEGER = 'integer',
  STRING = 'string',
  DATE = 'date',
  BOOLEAN = 'boolean',
  TO_MANY = 'to-many',
  TO_ONE = 'to-one',
  COMPOSITE = 'composite',
}
